import { gql } from '@/__generated__';

/**
 * Movimientos v2 en curso para el banner global (AMARU-911). Selección mínima a propósito: el
 * fragmento completo del movimiento trae los mensajes, y esta query se refetchea con cada cambio
 * de pertenencia a la lista.
 */
export const GET_ACTIVE_GATE_MOVEMENTS = gql(`#graphql
  query GetActiveGateMovements {
    activeGateMovements {
      id
      gate {
        id
      }
      state
      closeCode
      expiresAt
      operationProgress
      startPosition
      requestedPosition
    }
  }
`);
